import {
  TooltipContent,
} from "@/components/ui/tooltip";

interface BadgeTooltipProps {
  name: string;
  description: string;
  isEarned: boolean;
  badgeType: string;
}

export const BadgeTooltip = ({ name, description, isEarned, badgeType }: BadgeTooltipProps) => {
  const getBadgeRequirements = (type: string) => {
    switch (type) {
      case 'tutorial_completed':
        return "Completa el tutorial de la aplicación";
      case 'first_routine':
        return "Completa tu primera rutina";
      case 'first_class':
        return "Asiste a tu primera clase";
      case 'workout_streak':
        return "Entrena 3 días seguidos";
      case 'class_enthusiast':
        return "Asiste a 5 clases diferentes";
      default:
        return "Logro especial";
    }
  };

  return (
    <TooltipContent 
      side="top" 
      className={`p-3 max-w-[200px] text-center ${
        isEarned 
          ? 'bg-clubbers-blue text-white' 
          : 'bg-gray-700 text-white'
      }`}
    >
      <p className="text-sm text-white font-medium mb-1">
        {name}
      </p>
      <p className="text-xs opacity-90 text-white ">
        {isEarned ? description : getBadgeRequirements(badgeType)}
      </p>
      {!isEarned && (
        <p className="text-xs mt-2 pt-2 border-t border-white/20">
          ¡Completa el desafío para desbloquear!
        </p>
      )}
    </TooltipContent>
  );
};